import { ALLOW_INTIAL_PAYMENT_EXTENSION_DAYS } from '../constants/constants';
import { AppliedPromotionRule } from '../types/types';

// Keeps Days Extension editable only when the applied promotion explicitly uses INCLUDE.
export const allowsStoreExtensionDays = (
  appliedPromotionRules: AppliedPromotionRule[] = []
): boolean =>
  appliedPromotionRules.some(
    (rule) =>
      rule.parameterKey.toUpperCase() === ALLOW_INTIAL_PAYMENT_EXTENSION_DAYS &&
      rule.promotionValue.toUpperCase() === 'INCLUDE'
  );
